export const beforeTraversal = (
  node: any,
  callback: (node: any, ancestors: Array<any>, index) => void,
  ancestors: Array<any> = [],
  index: number = 0
) => {
  callback(node, ancestors, index);
  index++;
  if (node.children) {
    node.children.map((child) => {
      beforeTraversal(child, callback, [...ancestors, node], index);
    });
  }
};
